<div class="l_flexbar">
  <div
    *ngIf="isCurrentStep; else isStepValid"
    class="wizard-indicator-number__solid guts-m-r-half"
    [ngClass]="{ '__large': size === 'large', '__medium': size === 'medium' }"
  >
    <div>
      {{ stepIndex + 1 }}
    </div>
  </div>
  <div  class="font-medium wizard-label" [class.color-ebony-a61]="!isCurrentStep"
    [ngClass]="{ '__large': size === 'large', '__medium': size === 'medium' }"
  >
    {{ stepTitle }}
  </div>
</div>
<ng-template #isStepValid>
  <div
    [class.color-blue]="stepIsValid"
    class="guts-m-r-half wizard-indicator-number__circled"
    [ngClass]="{ '__large': size === 'large', '__medium': size === 'medium' }"

  >
    <df-icon
      *ngIf="stepIsValid; else stepNumber"
      icon="checkmark"
      size="small"
      class="color-blue"
    ></df-icon>
  </div>
</ng-template>
<ng-template #stepNumber>
  <div>{{ stepIndex + 1 }}</div>
</ng-template>
